import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { AchatsStateType } from './types';
import { CATEGORIE_STATS_SLICE_NAME } from './slices/categorieStatsSlice';
import { CODES_REJETS_SLICE_NAME } from './slices/codeRejetSlice';
import { EXCEPTIONS_FACTURANTES_SLICE_NAME } from './slices/exceptionFacturante';
import { DEF_FREQUENCE_SLICE_NAME } from './slices/defFrequenceSlice';
import { CODE_REJET_STATS_SLICE_NAME } from './slices/codeRejetStatsSlice';
import { FACTURES_ACHATS_SLICE_NAME } from './slices/factureAchatSlice';
import { INVOICE_STATEMENT_SLICE_NAME } from './slices/invoiceStatementSlice';
import { MEDIAOBJECT_SLICE_NAME } from './slices/mediaObjectsSlice';
import { REMINDER_PUBLISHER_SLICE_NAME } from './slices/reminderPublisherSlice';
import { ACHATS_REDUCER_NAME } from './constants';

export const CategorieStatsSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][CATEGORIE_STATS_SLICE_NAME];

export const CodeRejetStatsSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][CODE_REJET_STATS_SLICE_NAME];

export const DefFrequenceSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][DEF_FREQUENCE_SLICE_NAME];

export const ExceptionFacturanteSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][EXCEPTIONS_FACTURANTES_SLICE_NAME];

export const ReminderPublisherSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][REMINDER_PUBLISHER_SLICE_NAME];

export const CodeRejetSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][CODES_REJETS_SLICE_NAME];

export const InvoiceStatementSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][INVOICE_STATEMENT_SLICE_NAME];

export const FactureachatSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][FACTURES_ACHATS_SLICE_NAME];

export const MediaObjectSelector = (s: AchatsStateType) =>
    s[ACHATS_REDUCER_NAME][MEDIAOBJECT_SLICE_NAME];

// export const getMediaObjectByViewName = <T extends ViewName>(dataSourceName: T) =>
//     getSpecifiedDataSourceByViewName(mediaobjectDataSourcesThunks, dataSourceName);

export const useAchatsServiceSelector: TypedUseSelectorHook<AchatsStateType> = useSelector;
